const arrayOfCount = (count, callback) => {
  let array = [];
  for (let i = 1; i <= count; i++) {
    array.push(callback(i));
  }
  return array;
};

export default arrayOfCount;
